export default "/list/static/images/lyp-hero.svg";